import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables'
import { InlineWidget } from 'react-calendly'
import { Header1, Text } from '../../styles/Components'
import { mq } from '../../helpers'
import axios from 'axios'

const calendlyPageSettings = {
  backgroundColor: 'ffffff',
  hideEventTypeDetails: false,
  hideLandingPageDetails: false,
  primaryColor: gsColors.cobalt,
  textColor: gsColors.cobalt,
  hideGdprBanner: true,
  branding: false,
}

const calendlyStyles = {
  width: '100%',
  height: '100%',
}

const isCalendlyEvent = (e) => {
  return e.data.event &&
    e.data.event.indexOf('calendly') === 0
}

const FormConfirmation = ({ formName, values, pageId }) => {
  const handleCalendlyEvent = async (e) => {
    try {
      if (isCalendlyEvent(e) && e.data.event === 'calendly.event_scheduled') {
        await axios({
          method: 'POST',
          url: `/api/events/${formName}`,
          data: {
            pageId,
            formName,
            properties: {
              'Calendly Scheduled': 'Yes'
            }
          }
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    window.addEventListener('message', handleCalendlyEvent)
    // prevent update of old event if client
    // books another event at later time
    localStorage.removeItem('pageId')

    return () => {
      window.removeEventListener('message', handleCalendlyEvent)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const calendlyMapping = {
    wedding: process.env.NEXT_PUBLIC_WEDDING_CALENDLY,
    event: process.env.NEXT_PUBLIC_EVENT_CALENDLY,
  }

  return (
    <FormHeaderContainer id="form-header">
      <Header1 align="center">Thank you for submitting your request</Header1>

      {(formName === 'wedding' || formName === 'event') && (
        <div className="calendly-container">
          <InlineWidget
            url={calendlyMapping[formName]}
            pageSettings={calendlyPageSettings}
            styles={calendlyStyles}
            branding={false}
            prefill={{
              // `values` can be null when the confirmation renders without a
              // submitted payload (seen in production after a Turnstile widget
              // crash on a long-lived tab); prefill is a nicety, never a crash
              email: values?.Email || '',
              firstName: values?.['First Name'] || '',
              lastName: values?.['Last Name'] || '',
              phone: values?.['Phone Number'] || '',
            }}
          />
        </div>
      )}

      {formName === 'out-of-zone' && (
        <Text fontSize={24} lineHeight="140%" spacing="0.24px">
          Our Concierge team will reach out to your shortly.
        </Text>
      )}
    </FormHeaderContainer>
  )
}

export default FormConfirmation

const FormHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f4ef;
  width: 100%;
  gap: 30px;
  padding: 60px 0 80px;
  box-sizing: border-box;

  ${mq('max', '768px')} {
    padding: 40px 16px;
  }

  h1 {
    max-width: 800px;
    box-sizing: border-box;
    word-wrap: break-word;
    text-align: center;
    min-width: 0;
  }

  p {
    max-width: 800px;
    text-align: center;
  }

  .calendly-container {
    width: 100%;
    // exact height of calendly widget on desktop
    height: 928px;
    margin-top: -50px;

    ${mq('max', '768px')} {
      margin-top: unset;
      // exact height of calendly widget with
      // "show more" dropdown open
      height: 1091px;
    }
  }
`
